import Index from '@/pages/Index'
import Scan from '@/pages/Scan'
import WxAuth from '@/pages/WxAuth'
import upload from '@/pages/upload'

let router = [{
    path: "/scan",
    name: "scan",
    component: Scan,
    meta: {
      title: 'TMS运输管理系统',
      keepAlive: true,
      role: [0]
    }
  }, {
    path: "/auth",
    name: "auth",
    component: WxAuth,
    meta: {
      title: '授权中',
      keepAlive: true,
      login: false // 是否需要登录
    }
  }, {
    path: "/upload",
    name: "upload",
    component: upload,
    meta: {
      title: '',
      keepAlive: true,
      login: false // 是否需要登录
    }
  }, {
    path: "*",
    name: "index",
    component: Index,
    meta: {
      title: 'TMS运输管理系统',
      keepAlive: true,
      role: [0]
    }
  }
];
export default router;



// WEBPACK FOOTER //
// ./src/router/base.js